import styled from "styled-components";
import { GRAY, LIGHT_GRAY, NEAR_BLACK, NEAR_WHITE, WHITE } from "../../config";
import { getRiskColorByName } from "../../utils";


export const Container = styled.div<{ between?: boolean; hasTitle?: boolean; size?: string }>`
  display: flex;
  flex-direction: column;
  min-width: ${({ size }) => (size === "small" ? "0" : "350")}px;
  padding: ${({ between }) => (between ? "1.5rem 0 2rem" : "2rem 0 0")};
  padding-top: ${({ hasTitle }) => (hasTitle ? "2rem" : "0")};
  margin-bottom: 10px;
  width: fit-content;
`;

export const BoxLabelTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
  color: ${WHITE};
  margin: 0px;
`;

export const Content = styled.div<{ between?: boolean; isCtoFilter?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: ${({ between }) => (between ? "start" : "space-between")};
  align-items: flex-end;
  align-content: center;
  padding-top: ${({ isCtoFilter }) => (isCtoFilter ? "1" : "0.5")}rem;
  margin-bottom: ${({ isCtoFilter }) => (isCtoFilter ? "0.5" : "0")}rem;
  flex-wrap: wrap;
  gap: ${({ isCtoFilter }) => (isCtoFilter ? "2.5" : "0")}rem;
`;

export const BoxItem = styled.div<{
  between?: boolean;
  isCtoFilter?: boolean;
  isDisabled?: boolean;
}>`
  margin-right: ${({ between }) => (between ? "2rem" : "0")};
  min-width: 30px;
  height: ${({ isCtoFilter }) => (isCtoFilter ? "56px" : "unset")};
  display: ${({ isCtoFilter }) => (isCtoFilter ? "flex" : "unset")};
  flex-direction: ${({ isCtoFilter }) => (isCtoFilter ? "column" : "unset")};
  justify-content: ${({ isCtoFilter }) => (isCtoFilter ? "space-between" : "unset")};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
`;

export interface RiskBoxLabelProps {
  color?: string;
  size?: string;
  facilities?: boolean;
  active?: boolean;
  isFacilitiesFilter?: boolean;
  isCtoFilter?: boolean;
}

export const RiskBoxLabelCount = styled.div.attrs({ "data-testid": "risk-box" }) <RiskBoxLabelProps>`
  width: ${({ size }) => (size === "small" ? "12" : "24")}px;
  height: ${({ size }) => (size === "small" ? "12" : "24")}px;
  border-radius: ${({ size }) => (size === "small" ? "3" : "5")}px;
  box-sizing: border-box;
  outline: none;
  user-select: none;
  margin-right: ${({ size }) => (size === "small" ? "0.5" : "0.75")}rem;
  background-color: ${({ color, facilities }) => {
    const colorHex = color?.startsWith("#") ? color : getRiskColorByName(undefined, color);
    return color !== "#565656" ? colorHex : facilities ? `${NEAR_BLACK}` : `${GRAY}`;
  }};
`;

export const RiskText = styled.div.attrs({ "data-testid": "risk-text" }) <RiskBoxLabelProps>`
  display: flex;
  width: 14px;
  font-style: normal;
  font-weight: ${({ size }) => (size === "small" ? "400" : "500")};
  font-size: ${({ size }) => (size === "small" ? "10" : "12")}px;
  line-height: 12px;
  color: ${({ active, isFacilitiesFilter }) =>
    active || isFacilitiesFilter ? NEAR_WHITE : LIGHT_GRAY};
  margin-right: 2px;
  text-transform: ${({ size }) => (size === "small" ? "uppercase" : "normal")};

  > p {
    margin: ${({ isCtoFilter }) => (isCtoFilter ? "0" : "revert")};
  }
`;

export const InfoContainer = styled.div.attrs({ "data-testid": "risk-value" }) <{
  size?: string;
  isCtoFilter?: boolean;
}>`
  display: flex;
  justify-content: ${({ size }) => (size === "small" ? "left" : "center")};
  align-items: center;
  margin-bottom: ${({ isCtoFilter }) => (isCtoFilter ? "0" : "0.5")}rem;
  margin-top: ${({ size }) => (size === "small" ? "0.25" : "0.5")}rem;
`;

export const ValueText = styled.span<RiskBoxLabelProps>`
  font-style: normal;
  font-weight: ${({ size }) => (size === "small" ? "400" : "bold")};
  font-size: ${({ size }) => (size === "small" ? "14" : "18")}px;
  color: ${({ active, isFacilitiesFilter }) =>
    active || isFacilitiesFilter ? NEAR_WHITE : LIGHT_GRAY};
`;
